import gql from 'graphql-tag';

const MUTATION_CREATE_TICKET_ZENDESK = gql`
  mutation createZendeskTicket($input: CreateTicketInput!) {
    createTicket(input: $input) {
      id
      status
    }
  }
`;

const createZendeskTicket = client => ({ input }) =>
  client.mutate({
    mutation: MUTATION_CREATE_TICKET_ZENDESK,
    variables: { input }
  });

export default createZendeskTicket;
